const MIN_FRAMES_FOR_SCRUBBING = 3;
const FALLBACK_FRAME_COUNT = 50;

export const getPaddedScrubRange = (
  startsAtInSeconds: number,
  endsAtInSeconds: number,
  videoDuration?: number,
  scrubFrameCount: number | undefined = FALLBACK_FRAME_COUNT
) => {
  if (!videoDuration || videoDuration === 0) {
    return {
      paddedStartsAt: startsAtInSeconds,
      paddedEndsAt: endsAtInSeconds,
    };
  }

  // Calculate the duration of the clip in seconds
  const clipDuration = endsAtInSeconds - startsAtInSeconds;

  // Calculate how many frames are available for this clip duration
  const availableFrames = (clipDuration / videoDuration) * scrubFrameCount;

  // If we meet the minimum number of frames, return the original start and end times
  if (availableFrames >= MIN_FRAMES_FOR_SCRUBBING) {
    return {
      paddedStartsAt: startsAtInSeconds,
      paddedEndsAt: endsAtInSeconds,
    };
  }

  // Calculate minimum duration needed for MIN_FRAMES_FOR_SCRUBBING
  const minDuration =
    (MIN_FRAMES_FOR_SCRUBBING / scrubFrameCount) * videoDuration;

  // Keep the start frame accurate, try to pad the end first
  let paddedStartsAt = startsAtInSeconds;
  const paddedEndsAt = Math.min(videoDuration, startsAtInSeconds + minDuration);

  // If we hit the end boundary and don't have enough duration, pad the start as well
  const achievedDuration = paddedEndsAt - paddedStartsAt;
  if (achievedDuration < minDuration) {
    paddedStartsAt = Math.max(0, paddedEndsAt - minDuration);
  }

  return {
    paddedStartsAt,
    paddedEndsAt,
  };
};
